import {Paragraph} from "@reside/ui";
import {FunctionComponent, PropsWithChildren} from "react";

export const SlideParagraph: FunctionComponent<PropsWithChildren<{}>> = ({
  children,
}) => (
  <Paragraph fontSize="1.25em" lineHeight="1.75em">
    {children}
  </Paragraph>
);
